import React from 'react'

import type { PrescriptionTimelineItem } from '~/types'

import { LabelValueWrapper } from './LabelValueWrapper'
import { useDispenseRefill } from './useDispenseRefill'
import { useRxCardContent } from './useRxCardContent'

import styles from './RxCardDetails.module.scss'

export interface RxCardDetailsProps {
  item: PrescriptionTimelineItem
}

export const RxCardDetails = ({ item }: RxCardDetailsProps) => {
  const { prescription } = item

  const handleDispenseRefill = useDispenseRefill(item)

  const rxContent = useRxCardContent(prescription, {
    itemDate: item.date,
    onDispenseRefill: handleDispenseRefill,
  })

  return (
    <div className={styles.container}>
      <div className={styles.fieldsGrid}>
        {rxContent.fields.map((field) => (
          <LabelValueWrapper
            boldValue={field.boldValue}
            key={field.label}
            label={field.label}
            tooltipText={field.tooltipText}
            value={field.value}
            onClick={field.onClick}
          />
        ))}
      </div>
      {rxContent.showTime && (
        <div className={styles.timeDisplay}>{rxContent.showTime}</div>
      )}
      {rxContent.showInstructions && (
        <>
          <div className={styles.divider} />
          <div className={styles.instructionsContainer}>
            <LabelValueWrapper
              label={rxContent.instructions.label}
              value={rxContent.instructions.value}
            />
          </div>
        </>
      )}
    </div>
  )
}
